<template lang="pug">
  div(v-cloak).sub-page
    CommonHeader
    main
      v-container
        h1 プライバシーポリシー
        v-layout.white_container.pa-3.justify-center(row wrap)
          v-container
            p.mb-5 株式会社大谷商会（以下「当社」という）では個人情報保護の重要性を認識し、個人情報保護法その他の法令を遵守し、以下の方針に基づき個人情報の保護に努めます。
            dl(v-for='(item, index) in list' :key='item.title')
              dt.mt-5.mb-3.text-primary {{ item.title }}
              dd {{ item.text }}

    CommonFooter

</template>

<script>
import CommonHeader from '@/app/pages/Landing/Header.vue'
import CommonFooter from '@/app/pages/Landing/Footer.vue'

export default {
  components: {
    CommonHeader,
    CommonFooter
  },
  mounted: function () {
  },
  data () {
    return {
      list: [
        {
          'title': '1.個人情報の利用目的',
          'text': 'お客様からお預かりする個人情報は、お客様へのご回答、ご連絡やプレゼントの送付、サービスに関する業務に利用し、法律に基づき開示が義務づけられている等の事情がない限り、お客様の承諾なく目的外利用及び第三者に開示・提供することはありません。'
        }, {
          'title': '2.個人情報の安全対策',
          'text': 'お客様の個人情報を安全に管理・運営するよう、個人情報への外部からの不正なアクセス、個人情報の紛失・毀損・破壊・改ざん・漏洩、社外への不正な流出などへの危険防止に対する適切な安全対策を行っています。'
        }, {
          'title': '3.個人情報の開示・訂正・削除',
          'text': '当社は、お客様から自己の個人情報について、開示、訂正、削除を求められた場合、適正な本人確認を行った後、法令の趣旨に則って合理的な範囲で速やかに対応します。'
        }, {
          'title': '4.法令・規範の遵守',
          'text': '当社は、個人情報の取扱いにおいて個人情報の保護に関する法令およびその他の規範を遵守します。'
        }
      ]
    }
  },
  computed: {
  }
}
</script>

<style scoped lang="stylus">
// breakpoint
screen-xs = 600px
screen-sm = 960px
breakpoint(bpName)
    for name in bpName
        if name == 'sm-up'
            @media only screen and (min-width: screen-xs)
                {block}
        if name == 'xs'
            @media only screen and (max-width: screen-xs)
                {block}
        if name == 'sm'
            @media only screen and (max-width: screen-sm)
                {block}

// color
$color-primary = #502e28
$color-secondary = #ecddbc

dt
  font-weight bold
  text-align center
  border-bottom 1px solid $color-primary
</style>



// WEBPACK FOOTER //
// src/app/pages/Landing/Privacy/index.vue